import home from "./home";
import dataDownload from "./datadownload";
import selectiveCourse from "./selectivecourse";
import importantNotice from "./importantnotice";
import toDoList from "./todolist";
import calendar from "./calendar";
import feedback from "./feedback";
import mySummary from "./mysummary";
import projectComment from "./projectcomment";
import evaluateServiceQuality from "./evaluateservicequality";
import selectClassCenter from "./selectClassCenter";

const course = {
  path: "course",
  component: resolve => require(["../../../pages/user/course"], resolve),
  children: [
    selectClassCenter,
    home,
    dataDownload,
    selectiveCourse,
    importantNotice,
    toDoList,
    calendar,
    feedback,
    mySummary,
    projectComment,
    evaluateServiceQuality
  ]
};

export default course;



// WEBPACK FOOTER //
// ./src/router/user/course/index.js